/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

import orList from './orList';

/**
 * Given [ A, B, C ] return '"A", "B", or "C"'.
 */
export default function quotedOrList(items) {
  return orList(items.map(function (item) {
    return '"' + item + '"';
  }));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/module/jsutils/quotedOrList.js
// module id = 212
// module chunks = 0